export const documentTypeConstants = {
    DOCUMENT_TYPE_GET_REQUEST: 'DOCUMENT_TYPE_GET_REQUEST',
    DOCUMENT_TYPE_GET_SUCCESS: 'DOCUMENT_TYPE_GET_SUCCESS',
    DOCUMENT_TYPE_GET_FAILURE: 'DOCUMENT_TYPE_GET_FAILURE'
};